import React from "react";

function Hero() {
  return (
    <section className="hero flex-row">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 50 763 450">
        <g id="Layer_6" data-name="Layer 6">
          <text className="cls-3" transform="translate(260.81 292.69)">
            HACS
          </text>
          <g id="Inner_Ring" data-name="Inner Ring">
            <path
              className="cls-4"
              d="M603.52,271.72s-19.81-152.43-186-173.1l-1.14,29.28S341.15,117.57,275.12,183c-22.19,22-41.91,57.41-47.08,114.25l31,1.15S257.9,429.32,393.39,444"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-4"
              d="M373.58,98.62S265.76,109.73,216.85,214c-45.65,97.31.4,188.77,23.25,213.58,25.6,27.79,78.37,76.64,159,77.7l-2.65-30.77s71.4,2.9,122.14-45.79"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-4"
              d="M233.21,336.88S239,424.72,354.92,468.93"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-4"
              d="M439.32,501.66s152.72-24.12,166.5-190"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-4"
              d="M470.9,142.54s94.73,35.31,103.34,145.54c0,0,3.45,64.59-25,101.62"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-4"
              d="M271.1,244.16s34.45-94.73,141.24-87c116.41,8.45,133.48,119.71,133.48,141.24s-3.73,103.34-97.31,136.93"
              transform="translate(-20.57 -35.92)"
            />
            <circle className="cls-5" cx="352.23" cy="63.01" r="10.98" />
            <circle className="cls-5" cx="495.32" cy="393.39" r="10.98" />
            <circle className="cls-5" cx="529.55" cy="353.13" r="10.98" />
            <circle className="cls-5" cx="450.33" cy="106.83" r="10.98" />
            <circle className="cls-5" cx="250.31" cy="209.96" r="10.98" />
            <circle className="cls-5" cx="372.82" cy="408.03" r="10.98" />
            <circle className="cls-5" cx="334.35" cy="433.01" r="10.98" />
            <circle className="cls-5" cx="212.06" cy="298.66" r="10.98" />
            <circle className="cls-5" cx="418.75" cy="465.73" r="10.98" />
            <circle className="cls-5" cx="584.67" cy="275.63" r="10.98" />
            <circle className="cls-5" cx="583.16" cy="236.66" r="10.98" />
            <circle className="cls-5" cx="426.21" cy="399.64" r="10.98" />
          </g>
          <g id="Outer_Ring" data-name="Outer Ring">
            <line
              className="cls-6"
              x1="366.44"
              y1="5.52"
              x2="366.44"
              y2="33.94"
            />
            <line
              className="cls-6"
              x1="377.63"
              y1="5.52"
              x2="377.63"
              y2="33.94"
            />
            <line
              className="cls-6"
              x1="388.83"
              y1="5.52"
              x2="388.83"
              y2="33.94"
            />
            <line
              className="cls-6"
              x1="366.44"
              y1="497.52"
              x2="366.44"
              y2="525.94"
            />
            <line
              className="cls-6"
              x1="377.63"
              y1="497.52"
              x2="377.63"
              y2="525.94"
            />
            <line
              className="cls-6"
              x1="388.83"
              y1="497.52"
              x2="388.83"
              y2="525.94"
            />
            <line
              className="cls-6"
              x1="483.24"
              y1="24.64"
              x2="471.94"
              y2="50.71"
            />
            <line
              className="cls-6"
              x1="493.52"
              y1="29.09"
              x2="482.22"
              y2="55.16"
            />
            <line
              className="cls-6"
              x1="503.79"
              y1="33.54"
              x2="492.49"
              y2="59.61"
            />
            <line
              className="cls-6"
              x1="574.4"
              y1="88.87"
              x2="553.36"
              y2="107.98"
            />
            <line
              className="cls-6"
              x1="581.92"
              y1="97.16"
              x2="560.88"
              y2="116.26"
            />
            <line
              className="cls-6"
              x1="589.45"
              y1="105.45"
              x2="568.41"
              y2="124.55"
            />
            <line
              className="cls-6"
              x1="634.13"
              y1="198.5"
              x2="606.31"
              y2="204.28"
            />
            <line
              className="cls-6"
              x1="636.41"
              y1="209.46"
              x2="608.59"
              y2="215.24"
            />
            <line
              className="cls-6"
              x1="638.69"
              y1="220.43"
              x2="610.86"
              y2="226.2"
            />
            <line
              className="cls-6"
              x1="638.3"
              y1="310.56"
              x2="610.17"
              y2="306.51"
            />
            <line
              className="cls-6"
              x1="636.7"
              y1="321.64"
              x2="608.57"
              y2="317.59"
            />
            <line
              className="cls-6"
              x1="635.1"
              y1="332.72"
              x2="606.98"
              y2="328.67"
            />
            <line
              className="cls-6"
              x1="588.42"
              y1="423.97"
              x2="567.03"
              y2="405.26"
            />
            <line
              className="cls-6"
              x1="581.05"
              y1="432.39"
              x2="559.66"
              y2="413.69"
            />
            <line
              className="cls-6"
              x1="573.68"
              y1="440.82"
              x2="552.29"
              y2="422.11"
            />
            <line
              className="cls-6"
              x1="503.06"
              y1="496.33"
              x2="490.84"
              y2="470.68"
            />
            <line
              className="cls-6"
              x1="492.96"
              y1="501.15"
              x2="480.73"
              y2="475.5"
            />
            <line
              className="cls-6"
              x1="482.85"
              y1="505.97"
              x2="470.63"
              y2="480.31"
            />
            <polygon
              className="cls-7"
              points="410.42 34.28 449.11 43.41 434.9 11.12 410.42 34.28"
            />
            <polygon
              className="cls-7"
              points="410.42 34.28 449.11 43.41 434.9 11.12 410.42 34.28"
            />
            <polygon
              className="cls-7"
              points="582.52 147.51 599.71 183.35 615.92 152.01 582.52 147.51"
            />
            <polygon
              className="cls-7"
              points="598.65 350.84 579.55 385.69 614.46 380.59 598.65 350.84"
            />
            <path
              className="cls-8"
              d="M556.62,90.94a16.53,16.53,0,0,0-16.18,16.87,13.23,13.23,0,0,0,13.5,13A10.6,10.6,0,0,0,564.3,110c-.1-4.67-1.24-10.23-7.46-11.57-4.69-1-10.13,3.35-10.51,8.69-.3,4.13,4.5,9.73,9.47,7.63,2.21-.93,3.05-2.85,3-5.24,0-1.91.19-6.42-3.3-6.17-1.54.12-3.53,1.19-3.77,3.18a7.44,7.44,0,0,0,.88,3.73"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-8"
              d="M661.28,287.38a16.54,16.54,0,0,0-22.89,4.76,13.22,13.22,0,0,0,3.8,18.31,10.58,10.58,0,0,0,14.65-3c2.57-3.91,4.78-9.14.41-13.76-3.3-3.48-10.25-3-13.59,1.21-2.58,3.24-1.8,10.57,3.49,11.66,2.35.48,4.13-.63,5.44-2.63,1-1.6,3.8-5.19.77-6.95-1.33-.78-3.58-1-4.9.48a7.37,7.37,0,0,0-1.39,3.58"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-8"
              d="M566.47,503.94a16.52,16.52,0,0,0-12.87-19.52A13.22,13.22,0,0,0,538,494.71a10.57,10.57,0,0,0,8.23,12.49c4.58.94,10.26,1.07,12.94-4.7,2-4.34-1-10.62-6.14-12.18-4-1.2-10.48,2.23-9.54,7.55.41,2.35,2.1,3.6,4.44,4.08,1.88.39,6.22,1.62,6.75-1.85.23-1.52-.37-3.7-2.26-4.37a7.26,7.26,0,0,0-3.84,0"
              transform="translate(-20.57 -35.92)"
            />
            <line
              className="cls-6"
              x1="171.63"
              y1="111.65"
              x2="194.15"
              y2="128.99"
            />
            <line
              className="cls-6"
              x1="178.47"
              y1="102.78"
              x2="200.98"
              y2="120.12"
            />
            <line
              className="cls-6"
              x1="185.3"
              y1="93.91"
              x2="207.81"
              y2="111.25"
            />
            <line
              className="cls-6"
              x1="253.26"
              y1="36.61"
              x2="266.27"
              y2="61.87"
            />
            <line
              className="cls-6"
              x1="263.22"
              y1="31.48"
              x2="276.23"
              y2="56.75"
            />
            <line
              className="cls-6"
              x1="273.17"
              y1="26.36"
              x2="286.18"
              y2="51.62"
            />
            <line
              className="cls-6"
              x1="262.64"
              y1="494.89"
              x2="276.22"
              y2="469.93"
            />
            <line
              className="cls-6"
              x1="252.81"
              y1="489.54"
              x2="266.39"
              y2="464.58"
            />
            <line
              className="cls-6"
              x1="242.97"
              y1="484.19"
              x2="256.55"
              y2="459.23"
            />
            <line
              className="cls-6"
              x1="176.34"
              y1="426.44"
              x2="198.25"
              y2="408.33"
            />
            <line
              className="cls-6"
              x1="169.21"
              y1="417.8"
              x2="191.12"
              y2="399.7"
            />
            <line
              className="cls-6"
              x1="162.08"
              y1="409.17"
              x2="183.99"
              y2="391.07"
            />
            <line
              className="cls-6"
              x1="128.97"
              y1="331.88"
              x2="156.69"
              y2="325.62"
            />
            <line
              className="cls-6"
              x1="126.5"
              y1="320.95"
              x2="154.22"
              y2="314.7"
            />
            <line
              className="cls-6"
              x1="124.04"
              y1="310.03"
              x2="151.76"
              y2="303.78"
            />
            <line
              className="cls-6"
              x1="127.43"
              y1="214.49"
              x2="155.61"
              y2="218.18"
            />
            <line
              className="cls-6"
              x1="128.89"
              y1="203.39"
              x2="157.07"
              y2="207.08"
            />
            <line
              className="cls-6"
              x1="130.35"
              y1="192.28"
              x2="158.52"
              y2="195.98"
            />
            <polygon
              className="cls-7"
              points="239.16 449.02 209.96 422.05 206.47 457.16 239.16 449.02"
            />
            <polygon
              className="cls-7"
              points="149.36 281.29 149.31 241.54 121.17 262.83 149.36 281.29"
            />
            <polygon
              className="cls-7"
              points="216.89 99.61 248.07 74.95 213.93 66.05 216.89 99.61"
            />
            <path
              className="cls-8"
              d="M333.09,554.59a16.53,16.53,0,0,0,10.8-20.73,13.22,13.22,0,0,0-16.58-8.65,10.59,10.59,0,0,0-6.92,13.27c1.41,4.46,4.06,9.48,10.4,9,4.78-.34,8.79-6,7.66-11.29-.87-4-7-8.08-11.23-4.67-1.86,1.51-2.13,3.59-1.41,5.87.57,1.83,1.61,6.22,4.89,5,1.45-.54,3.06-2.13,2.73-4.1a7.32,7.32,0,0,0-1.89-3.34"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-8"
              d="M167,411.94A16.54,16.54,0,0,0,189.35,405a13.23,13.23,0,0,0-5.57-17.86,10.57,10.57,0,0,0-14.28,4.45c-2.17,4.14-3.87,9.55.93,13.73,3.61,3.15,10.49,2,13.4-2.52,2.26-3.47.77-10.69-4.6-11.26-2.38-.25-4,1-5.16,3.14-.89,1.69-3.27,5.53-.09,7,1.4.65,3.66.67,4.83-1a7.34,7.34,0,0,0,1-3.69"
              transform="translate(-20.57 -35.92)"
            />
            <polygon
              className="cls-7"
              points="408.67 498.14 447.14 488.15 433.65 520.75 408.67 498.14"
            />
            <path
              className="cls-8"
              d="M166.08,190.8A16.53,16.53,0,0,0,186,203a13.22,13.22,0,0,0,9.79-15.94A10.59,10.59,0,0,0,183,179.26c-4.55,1.09-9.74,3.38-9.73,9.74,0,4.79,5.42,9.19,10.72,8.43,4.1-.58,8.56-6.45,5.45-10.87-1.37-2-3.43-2.38-5.76-1.82-1.86.45-6.32,1.17-5.32,4.53.43,1.48,1.9,3.2,3.9,3a7.31,7.31,0,0,0,3.46-1.65"
              transform="translate(-20.57 -35.92)"
            />
            <path
              className="cls-8"
              d="M329.62,51A16.53,16.53,0,0,0,333.54,74,13.21,13.21,0,0,0,352,70.88a10.57,10.57,0,0,0-2.5-14.75c-3.81-2.71-9-5.11-13.74-.91-3.6,3.16-3.34,10.13.72,13.62,3.14,2.7,10.49,2.19,11.77-3.06.57-2.32-.47-4.15-2.42-5.53-1.56-1.11-5.05-4-6.92-1-.83,1.31-1.15,3.54.3,4.92a7.36,7.36,0,0,0,3.53,1.52"
              transform="translate(-20.57 -35.92)"
            />
            <circle className="cls-4" cx="382" cy="264.08" r="260.58" />
            <circle className="cls-4" cx="381" cy="265.08" r="232.52" />
            <circle className="cls-4" cx="381" cy="265.08" r="260.58" />
          </g>
        </g>
      </svg>
      <div className="content">
        <h1 className="welcome">Welcome to HACS!</h1>
        <p className="introduction">
          We're the Hispanic Association of Computer Scientists
        </p>
        <p className="description">
          The <span>Hispanic Association of Computer Scientists (HACS)</span>{" "}
          aims to empower and provide support for Hispanic and Latinx students
          in computer science through academic, professional, and social events.
        </p>
      </div>
    </section>
  );
}

export default Hero;
